import React from 'react';
import { Box, Group, Skeleton, Stack } from '@mantine/core';

export interface PostListSkeletonProps {
  count?: number;
}

/** Loading placeholder for blog post list rows (`PostCard`). */
export function PostListSkeleton ({ count = 5 }: PostListSkeletonProps) {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <Box
          key={i}
          sx={{
            background: 'var(--gs-surface)',
            border: '1px solid var(--gs-border)',
            borderRadius: 8,
            padding: 16
          }}
        >
          <Group spacing="sm" mb="sm">
            <Skeleton circle height={32} />
            <Box sx={{ flex: 1 }}>
              <Skeleton height={10} width="40%" mb={6} />
              <Skeleton height={8} width="25%" />
            </Box>
          </Group>
          <Skeleton height={14} mb={8} />
          <Skeleton height={14} width="80%" mb={8} />
          <Skeleton height={10} width="35%" />
        </Box>
      ))}
    </>
  );
}
